import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import { PrismicNextImage } from '@prismicio/next'

interface ArticleHeadingProps {
  page?: any | null
}

const ArticleHeading:React.FC<ArticleHeadingProps>  =({ page })=> {
    return (     
      <div className="font-fellix max-w-[1440px] mx-auto">
        <PrismicNextImage field={page.data.article_image} fallbackAlt="" className="w-full max-h-[60dvh] object-cover" sizes="100vw" priority/>
          {page.data.title_inside === true ? 
          <div className="p-4 md:p-8 lg:p-12"><PrismicRichText field={page.data.article_title}/></div>
          : 
          <div className="max-w-[700px] mx-auto pt-16 px-4">
            <article className="font-semibold text-[28px] leading-[36px] text-center mb-12">
              <PrismicRichText field={page.data.article_title}/>
              </article>
            <article className="text-[20px] md:text-[28px] leading-[28px] md:leading-[36px] text-center  prose prose-a:text-blue-500 prose-a:no-underline prose-a:hover:underline">
              <PrismicRichText field={page.data.article_tile_intro}/>
            </article>
          </div>}
      </div>
    )

};

export default ArticleHeading;
